import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=28e27059&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profile.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/Loading.vue').default,CustomError: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/CustomError.vue').default,ProfileHeader: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/profile/ProfileHeader.vue').default,ProfileLeftColumn: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/profile/left-column/ProfileLeftColumn.vue').default,ProfileRightColumn: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/profile/right-column/ProfileRightColumn.vue').default})
